import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { Task } from 'src/app/models/task.model';
import { getSteps } from './line-items-status.steps';

@Component({
  selector: 'app-line-items-status',
  templateUrl: './line-items-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class LineItemsStatusComponent {
  readonly completeStatuses = Object.freeze(['Complete', 'Skipped', 'Ready']);

  readonly orderType = input.required<string>();

  readonly tasks = input.required<Task[]>();

  readonly steps = computed(() => {
    const steps = getSteps(this.orderType());
    const tasks = this.tasks();

    const isEveryTaskComplete = (phaseName: string) => {
      const filteredTasks = tasks.filter(
        (t) => t.Phase_Name__c === phaseName && t.Status__c,
      );
      if (filteredTasks.length === 0) return false;
      return filteredTasks.every(({ Status__c }: Task) =>
        this.completeStatuses.includes(Status__c.trim()),
      );
    };

    let lastStatus: 'ACTIVE' | 'COMPLETED' | undefined = 'COMPLETED';
    steps.forEach((step) => {
      if (lastStatus === 'ACTIVE') return;
      step.status = isEveryTaskComplete(step.tasks.selector)
        ? 'COMPLETED'
        : 'ACTIVE';
      lastStatus = step.status;
    });

    return steps;
  });
}
